module.exports = __webpack_public_path__ + "static/media/medapps.5d11acb8.svg";